
import Vue from 'vue'
import twemoji from 'twemoji'

  export default {
    install: function(Vue) {
      Vue.prototype.$twemoji = twemoji
    }
  }


// WEBPACK FOOTER //
// ./src/modules/twemoji.js